export default __webpack_public_path__ + "static/media/Janice Green.80f1292f.webp";